<template>
    <render />
</template>

<script setup lang="ts">
import { defineAsyncComponent, h, resolveDirective, withDirectives } from 'vue'
import ThButton from '@/components/ui/buttons/ThButton.vue'

const render = () => {
    if (QA) {
        const IsAdminButton = defineAsyncComponent(
            () => import('@/components/qa/IsAdminButton.vue')
        )
        const NavButton = defineAsyncComponent(
            () => import('@/components/qa/NavButton.vue')
        )
        const FooterNavTextField = defineAsyncComponent(
            () => import('@/components/qa/FooterNavTextField.vue')
        )

        return h('div', [
            withDirectives(
                h(
                    ThButton,
                    {
                        to: {
                            name: 'test_nav_one',
                        },
                        'data-qa-footer-nav-dummy': 'one',
                    },
                    () => 'QA NAV DUMMY ONE'
                ),
                [
                    [
                        resolveDirective('qa'),
                        'one',
                        undefined,
                        { footer: true, nav: true, dummy: true },
                    ],
                ]
            ),
            withDirectives(
                h(
                    ThButton,
                    {
                        to: {
                            name: 'test_nav_two',
                        },
                        'data-qa-footer-nav-dummy': 'two',
                    },
                    () => 'QA NAV DUMMY TWO'
                ),
                [
                    [
                        resolveDirective('qa'),
                        'two',
                        undefined,
                        { footer: true, nav: true, dummy: true },
                    ],
                ]
            ),
            h(IsAdminButton),
            withDirectives(
                h(
                    ThButton,
                    {
                        to: {
                            name: 'test_base',
                        },
                    },
                    () => 'TEST ROOT'
                ),
                [
                    [
                        resolveDirective('qa'),
                        'test',
                        undefined,
                        { 'footer': true, 'nav': true },
                    ],
                ]
            ),
            withDirectives(
                h(
                    ThButton,
                    {
                        to: {
                            name: 'test_nav',
                        },
                    },
                    () => 'TEST NAV DUMMIES'
                ),
                [
                    [
                        resolveDirective('qa'),
                        'dummies',
                        undefined,
                        { 'footer': true, 'nav': true },
                    ],
                ]
            ),
            h(NavButton, {
                buttonName: 'footer',
            }),
            h('br'),
            h('br'),
            h(FooterNavTextField, {
                buttonName: 'footer',
            }),
            h('br'),
            h('br'),
        ])
    }

    return ''
}
</script>
